import React from "react";
import useMediaQuery from "@mui/material/useMediaQuery";

/**
 * Shared title banner used by listing/result pages.
 * Keeps the existing visual treatment while removing duplicate markup.
 */
export default function PageTitleBanner({ title }) {
  const isDesktop = useMediaQuery("(min-width:1000px)");

  return (
    <section className="main-slider style1">
      <div>
        <div className="row" style={{ backgroundColor: "#eaecef", width: "100%" }}>
          <div className="col-xl-12">
            <div
              style={{
                fontSize: isDesktop ? 60 : 30,
                padding: 50,
                textAlign: "center",
              }}
            >
              {title}
            </div>
            <div className="col-md-12 text-center" />
          </div>
        </div>
      </div>
    </section>
  );
}
